<template>
  <div v-if="items.length">
    <v-flex class="text-md-right subheading pointer" @click.stop="dialog = true">
      <v-icon medium>multiline_chart</v-icon>Indicadores financieros
    </v-flex>
    <v-dialog v-model="dialog" max-width="950">
      <v-card>
        <v-flex right>
          <v-icon medium @click="dialog = false">close</v-icon>
        </v-flex>
        <v-layout>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">Dolar</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>Hoy: ${{ formatNumbers(items[0].DOLAR) }}</div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">EURO</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>Hoy: ${{ formatNumbers(items[0].EURO) }}</div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">UF</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>
                    Hoy: ${{ formatNumbers(items[0].UF) }}
                    <p class="text-md-left subheading">
                      <b>{{items[0]['YESTERDAY']}}:</b>
                      ${{this.ufs[0]}}
                    </p>
                    <p class="text-md-left subheading">
                      <a
                        v-bind:href="`https://mercadosenlinea.inversionessecurity.cl/www/detalles.html?ID_NOTATION=210`"
                        target="blank"
                        class="link_inversion"
                      >Ir a Inversiones Security</a>
                    </p>
                  </div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">IPC</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>
                    Hoy:
                    ${{ formatNumbers(items[0].IPC) }}
                    <p class="text-md-left subheading">
                      <b>{{items[0]['MONTH_1']}}:</b>
                      ${{this.ipcs[0]}}
                    </p>
                    <p class="text-md-left subheading">
                      <b>{{items[0]['MONTH_2']}}:</b>
                      ${{this.ipcs[1]}}
                    </p>
                  </div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">UTM</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>
                    Hoy: ${{ formatNumbers(items[0].UTM) }}
                    <p class="text-md-left subheading">
                      <b>{{items[0]['MONTH_1']}}:</b>
                      ${{this.utms[0]}}
                    </p>
                    <p class="text-md-left subheading">
                      <b>{{items[0]['MONTH_2']}}:</b>
                      ${{this.utms[1]}}
                    </p>
                  </div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex>
            <v-card flat class="display-1 font-weight-thin">
              <v-card-title>
                <div class="text-truncate">IPSA</div>
              </v-card-title>
              <v-flex>
                <v-card-title class="subheading font-weight-light">
                  <div>
                    Hoy: ${{ formatNumbers(items[0].IPSA) }}
                    <p class="text-md-left subheading">
                      <b>Variación:</b>
                      {{ formatNumbers(items[0].IPSA_VARIATION) }}
                    </p>
                    <p class="text-md-left subheading">
                      <a
                        v-bind:href="`https://mercadosenlinea.inversionessecurity.cl/www/detalles.html?ID_NOTATION=3969`"
                        target="blank"
                        class="link_inversion"
                      >Ir a Inversiones Security</a>
                    </p>
                  </div>
                </v-card-title>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <b>{{this.items[0]['TODAY']}}</b>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import config from "@/config";
import axios from "axios";
const items = [];
const dolars = [];
const euros = [];
const ufs = [];
const ipcs = [];
const utms = [];
const ipsa = [];
const exhale = ms => new Promise(resolve => setTimeout(resolve, ms));
export default {
  data() {
    return {
      items: items,
      active: null,
      dolars: dolars,
      euros: euros,
      dialog: false
    };
  },
  methods: {
    formatNumbers(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    to_integer(value) {
      value.map(function(v) {
        return +v;
      });
    }
  },
  mounted() {
    let indicator = axios.get(process.env.VUE_APP_API_URL + "/indicators").then(
      response => (
        (this.items = response.data),
        (this.ufs = response.data[0]["LATEST_UF"].map(function(v) {
          return +v;
        })),
        (this.ipcs = response.data[0]["LATEST_IPC"].map(function(v) {
          return +v;
        })),
        (this.utms = response.data[0]["LATEST_UTM"].map(function(v) {
          return +v;
        })),
        (this.ipsa = response.data[0]["LATEST_IPSA"].map(function(v) {
          return +v;
        }))
      )
    );
  }
};
</script>
<style scoped>
.link_inversion {
  text-decoration: inherit;
  color: black;
  font-size: 12px;
}
/* .theme--dark {
  font-size: 10px;
} */
.v-card__text {
  background-color: lightgrey;
}

.v-card__text svg {
  background-color: white;
}
</style>

